import { useMemo } from "react";
import { useQuery } from "react-query";
import { getAllTasks } from "@/features/task/services/taskService";
import { useAuth } from "@/auth/useAuth";
import { enforceRestrictedAssigneeFilter } from "@/features/task/utils/filterUtils";
const useTimelineTasks = (filters = {}) => {
    const { user } = useAuth();
    const enforcedFilters = useMemo(() => enforceRestrictedAssigneeFilter(filters, user), [filters, user]);
    const { data, error, isLoading, refetch } = useQuery(["timelineTasks", JSON.stringify(enforcedFilters)], () => getAllTasks(enforcedFilters), {
        staleTime: 60000,
    });
    return {
        tasks: data?.tasks || [],
        loading: isLoading,
        error: error ? error.message : null,
        refetchTimelineTasks: refetch,
    };
};
export default useTimelineTasks;
